import { ColDef } from "ag-grid-enterprise";
import { CustomColDef } from "./SnGrid_Types";

export function computeFooterSummary(
  gridApi: any,
  resolvedColumnDefs: ColDef[],
  setPinnedBottomRowData: (data: any[]) => void,
  pinnedBottomRowData: any[]
) {
  if (!gridApi) return;

  const allFilteredData: any[] = [];
  gridApi.forEachNodeAfterFilter((node: any) => {
    if (node.data) allFilteredData.push(node.data);
  });

  const customColumnDefs = resolvedColumnDefs as CustomColDef[];
  const targetFields = customColumnDefs
    .filter((col) => col.yn_sum === "Y")
    .map((col) => col.field)
    .filter((field): field is string => !!field);

  const totalRow = targetFields.reduce(
    (acc, field) => {
      const sum = allFilteredData.reduce(
        (sum, row) => sum + Number(row[field] || 0),
        0
      );
      acc[field] = sum;
      return acc;
    },
    {} as Record<string, number>
  );
  totalRow["cnt_row"] = allFilteredData.length;

  if (JSON.stringify(pinnedBottomRowData[0]) !== JSON.stringify(totalRow)) {
    setPinnedBottomRowData([totalRow]);
  }
}

export function getFooterData(pinnedBottomRowData: any[]) {
  const footer = pinnedBottomRowData.length > 0 ? pinnedBottomRowData[0] : {};
  return new Proxy(footer, {
    get: (target, prop: string) => (prop in target ? target[prop] : null),
  });
}

export function getFooterDataAsync(
  computeFooterSummary: () => void,
  pinnedBottomRowData: any[]
) {
  return new Promise((resolve) => {
    computeFooterSummary();
    setTimeout(() => resolve(pinnedBottomRowData[0]), 0);
  });
}
